import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button, Grid } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { faFileExcel } from '@fortawesome/free-regular-svg-icons';
import { DATATYPES } from './consts';
import EditorControls from '../../BaseEditor/editorControls';
import { AppContext } from '../../../providers/authProvider';

function DKSUData({
  dataType, setDataType, date, setDate, getDKSUData, datesByType, lastDownload, logicaPingSuccess,
  period, onSetPeriod, periodAvailable, uploadAll, selectKDB, setSelectKDB,
}) {
  const {
    currentUser,

  } = useContext(AppContext);

  return (
    <Grid container spacing={2}>
      <Grid item sm={3}>
        <EditorControls.Selector
          label="Оберіть тип даних для завантаження"
          required
          value={dataType}
          values={DATATYPES.map((data) => ({ value: data, display_name: data }))}
          onChange={(e, data) => {
            if (dataType !== '@B') setSelectKDB(null);
            setDataType(data);
            onSetPeriod({
              end: (datesByType.length > 0)
                ? datesByType[datesByType.length - 1].value : datesByType[0].value,
              start: datesByType[0].value,
            });
          }}
        />
      </Grid>
      <Grid item sm={3}>
        <EditorControls.StringInput
          label="В останнє завантажено на:"
          value={lastDownload}
          readOnly
        />
      </Grid>
      <Grid item sm={3} display="flex" gap={2}>
        {!periodAvailable ? (
          <>
            {currentUser.is_superuser && (
            <EditorControls.CheckboxInput
              controlId="is_upload-all"
              label="Завантажити всі дані"
              value={uploadAll.isUploadAll}
              onChange={(e, v) => {
                uploadAll.setUploadAll(v);
                if (v) {
                  setDate(datesByType[0]);
                }
              }}
            />
            )}
            {!uploadAll.isUploadAll ? (
              <EditorControls.Selector
                label="Оберіть дату"
                required
                value={date}
                values={datesByType || []}
                onChange={(e, data) => setDate(data)}
                readOnly={!dataType}
              />
            ) : (
              <>
                <EditorControls.Selector
                  label="За період з "
                  required
                  value={period.start}
                  values={datesByType || []}
                  onChange={(e, v) => {
                    onSetPeriod((o) => ({ ...o, start: v }));
                  }}
                  readOnly={!dataType}
                />
                <EditorControls.Selector
                  label="по"
                  required
                  value={period.end}
                  values={datesByType || []}
                  onChange={(e, v) => onSetPeriod((o) => ({ ...o, end: v }))}
                  readOnly={!dataType}
                />
              </>
            )}
          </>
        ) : (
          <>
            <EditorControls.DateInput
              label="За період з "
              required
              value={period.start}
              onChange={(e, v) => onSetPeriod((o) => ({ ...o, start: v }))}
              readOnly={!dataType}
              helpText={`Мінімальне значення ${datesByType[0].display_name}`}
            />
            <EditorControls.DateInput
              label="по"
              required
              value={period.end}
              onChange={(e, v) => onSetPeriod((o) => ({ ...o, end: v }))}
              readOnly={!dataType}
              helpText={`Максімальне значення ${datesByType[datesByType.length - 1].display_name}`}
            />
          </>
        )}
      </Grid>
      <Grid item sm={3} display="flex" justifyContent="space-between" alignItems="center" flexDirection="column" gap={2}>
        <>
          <Button
            color="success"
            onClick={() => getDKSUData(false)}
            disabled={!logicaPingSuccess}
            variant="contained"
            startIcon={<FontAwesomeIcon icon={faUpload} />}
          >
            Завантажити
          </Button>

          {!uploadAll.isUploadAll && dataType && date && (
          <Button
            color="success"
            variant="contained"
            startIcon={<FontAwesomeIcon icon={faFileExcel} />}
            onClick={() => getDKSUData(true)}
          >
            Експортувати в xlsx
          </Button>
          )}
        </>
      </Grid>
      {(dataType === '@B') && (
      <EditorControls.ItemPicker
        label="Завантажити за обраним КДБ"
        backend="/api/catalog/kdbs/"
        canErase
        value={selectKDB}
        onChange={(e, v) => {
          setSelectKDB(v);
        }}
        mode="no-repr"
      />
      )}
    </Grid>
  );
}

DKSUData.propTypes = {
  dataType: PropTypes.string,
  setDataType: PropTypes.func.isRequired,
  setSelectKDB: PropTypes.func.isRequired,
  selectKDB: PropTypes.shape({
    code: PropTypes.string,
  }),
  date: PropTypes.string,
  setDate: PropTypes.func.isRequired,
  getDKSUData: PropTypes.func.isRequired,
  datesByType: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    display_name: PropTypes.string,
  })),
  lastDownload: PropTypes.string,
  logicaPingSuccess: PropTypes.bool.isRequired,
  period: PropTypes.shape({
    start: PropTypes.string,
    end: PropTypes.string,
  }).isRequired,
  onSetPeriod: PropTypes.func.isRequired,
  periodAvailable: PropTypes.bool,
  uploadAll: PropTypes.shape({
    setUploadAll: PropTypes.func,
    isUploadAll: PropTypes.bool,
  }),
};

DKSUData.defaultProps = {
  dataType: null,
  date: null,
  lastDownload: null,
  periodAvailable: false,
  datesByType: [{
    value: '',
    display_name: '',
  }],
  uploadAll: {
    isUploadAll: false,
  },
  selectKDB: {
    code: '',
  },
};

export default DKSUData;
